import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { CSS } from "src/_utils/styles";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import Page from "src/base/Page";
import { ProductFeatures, ProductGrid, SkeletonLoader } from "../Products/ProductsCommon";
import { EBSSSPagination } from "src/base/atoms/EBSSSPagination";
import { useSelector } from "react-redux";
import { ReduxDataKey } from "src/base/store/store";
import { getQueryParams } from "src/_utils/urls";
import { scrollUpPage } from "src/_utils/elements";
import { Session } from "src/base/store/authSlice";
import { H5, Image } from "src/AbstractElements";
import EBSSSTooltip from "src/base/atoms/EBSSSTooltip";
import EBSSSModal from "src/base/atoms/EBSSSModal";
import { remotePath } from "src/base/settings/Paths";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
import Slider from "react-slick";
import { LeftArrowSlider, RightArrowSlider } from "../DashBoard/IndexPage";

export const SlickSlider = ({ slides, rtl, title, lazyLoad, autoplay, focusOnSelect, isGallery, CTA }) => {
  var settings = {
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: autoplay,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerPadding: "10px",
    centerMode: false,
    rtl: rtl,
    focusOnSelect: focusOnSelect,
    lazyLoad: lazyLoad,
    nextArrow: <RightArrowSlider />,
    prevArrow: <LeftArrowSlider />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <div className="px-5" style={{ minHeight: 150 }}>
        <Slider {...settings}>
          {slides.map((item, index) => (
            <div key={index} className="slider-item" style={{ padding: "10px" }}>
              {isGallery ? (
                <Zoom>
                  <img
                    alt="Slider"
                    src={remotePath.assetsUrl(item.image)}
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "150px", // Adjust if needed
                      objectFit: "contain",
                    }}
                  />
                </Zoom>
              ) : (
                <div style={{ textAlign: "center" }}>
                  {item.image ? (
                    <img
                      src={remotePath.assetsUrl(item.image)}
                      alt=""
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "150px", // Adjust as needed
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <img
                      src="https://cdn.pixabay.com/photo/2022/01/12/00/27/gallery-6931706_1280.png"
                      alt=""
                      style={{
                        width: "100%",
                        height: "auto",
                        maxHeight: "150px", // Adjust as needed
                        objectFit: "contain",
                      }}
                    />
                  )}
                  {item.title && <p>{item.link ? <Link to={item.link}>{item.title}</Link> : item.title}</p>}
                </div>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

const WeekdaySchedule = ({ data, trans }) => {
  const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  // Create a map to track which weekdays have already been rendered
  const renderedWeekdays = new Set();

  return (
    <div>
      <table className="table" border={1} style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>{trans("website.weekday")}</th>
            <th>{trans("website.open-at")}</th>
            <th>{trans("website.close-at")}</th>
          </tr>
        </thead>
        <tbody>
          {data
            ?.sort((a, b) => a.weekday - b.weekday)
            ?.map((item) => {
              const showWeekday = !renderedWeekdays.has(item.weekday);
              if (showWeekday) {
                renderedWeekdays.add(item.weekday);
              }

              return (
                <tr key={item.id}>
                  <td>{showWeekday ? trans("calendar." + weekdays[item.weekday].toLowerCase()) : ""}</td>
                  <td>{item.start_at}</td>
                  <td>{item.end_at}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

const SellerPage = () => {
  const { trans } = useEBSSSLayout();
  const getSeller = useParams();
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const { products, categories, seller, loaded, appSettings, fetchSeller } = useEBSSS();
  const [page, setPage] = useState(null);
  const [ordering, setOrdering] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [filterSize, setFilterSize] = useState(undefined);
  const [stepSize, setStepSize] = useState(0);
  const [values, setValues] = useState([1, 100]);
  const [modal, setModal] = useState("");
  const [filterPrice, setFilterPrice] = useState({
    min: 0,
    max: undefined,
  });

  const toggle = (id) => {
    if (modal === id) {
      setModal("");
      return;
    }
    setModal(id);
  };

  useEffect(() => {
    if (!!products && Array.isArray(products?.data) && products?.data?.length) {
      let filtersPriceMinMax = {
        ...filterPrice,
        max: Math.ceil(Number(products?.data?.sort((a, b) => Number(b.price) - Number(a.price))[0]?.price)),
      };
      setFilterPrice({
        ...filtersPriceMinMax,
      });
      setStepSize(
        //@ts-ignore
        String(products?.data?.sort((a, b) => Number(b.price) - Number(a.price))[0]?.price ?? 0) / 20
      );
      setValues([filtersPriceMinMax.min, filtersPriceMinMax.max]);
    }
  }, [products?.data]);

  useEffect(() => {
    let actualParams = getQueryParams(window.location.href);
    if (actualParams?.page) {
      setPage((p) => {
        if (p !== null) {
          return p;
        } else {
          return Number(actualParams?.page);
        }
      });
    }
  }, [window.location.search]);

  useEffect(() => {
    scrollUpPage();
    if (products?.data) {
      if (page && page > 0) {
        fetchSeller(getSeller?.slug, page);
      }
    }
  }, [page]);

  useEffect(() => {
    scrollUpPage();
    fetchSeller(getSeller?.slug, { page: 1 });
  }, []);

  console.log(seller?.seller?.photo);

  return (
    <Page breads={[]} hideTitle hideBreadcrumbs>
      <div className="d-flex flex-column pt-4">
        <div className="w-100 p-4 mb-3" style={CSS({ height: 200, backgroundColor: "#00000000" })}>
          {loaded ? (
            <div className="d-flex flex-row justify-content-between">
              <div className="d-flex flex-column gap-3">
                {(appSettings?.images && appSettings?.images?.length > 0) || seller?.seller?.photo || seller?.seller?.profile?.avatar ? (
                  <Image
                    attrImage={{
                      className: "img-fluid",
                      src: seller?.seller?.photo
                        ? remotePath.assetsUrl(seller?.seller?.photo)
                        : seller?.seller?.profile?.avatar
                        ? remotePath.assetsUrl(seller?.seller?.profile?.avatar)
                        : appSettings?.images[0],
                      width: 100,
                      height: "auto",
                    }}
                  />
                ) : (
                  <></>
                )}
                <div className="d-flex flex-row gap-2 align-items-baseline">
                  <h3>{appSettings?.seller_fullname}</h3>
                  {appSettings?.verified === "enabled" ? <EBSSSTooltip icon="la la-check" title={trans("website.verified")} /> : <></>}
                </div>
                <EBSSSModal
                  hideFooter
                  modalTitle={trans("website.working-hours")}
                  toggle={() => toggle("working-hours")}
                  modal={modal === "working-hours"}
                  triggerEl={
                    appSettings?.opened ? (
                      <span
                        onClick={() => toggle("working-hours")}
                        style={CSS({ cursor: "pointer" })}
                        className="badge bg-success d-flex align-items-center justify-content-center gap-1"
                      >
                        <i className="la la-clock fs-5 me-1"></i> {trans("common.store-open")}
                      </span>
                    ) : appSettings?.opened === null ? (
                      <span className="badge bg-danger">{trans("common.store-unavailable-work-hour")}</span>
                    ) : (
                      <span
                        onClick={() => toggle("working-hours")}
                        style={CSS({ cursor: "pointer" })}
                        className="badge bg-warning d-flex align-items-center justify-content-center gap-1"
                      >
                        <i className="la la-clock fs-5 me-1"></i> {trans("common.store-closed")}
                      </span>
                    )
                  }
                >
                  <WeekdaySchedule data={appSettings?.workingHours} trans={trans} />
                </EBSSSModal>
              </div>
              <div className="d-flex flex-column">
                {appSettings?.address ? (
                  <div className="d-flex flex-column">
                    <span>
                      {appSettings?.address?.address_line_1} {appSettings?.address?.address_line_2}
                    </span>
                    <span>{appSettings?.address?.postal_code}</span>
                    <span>{appSettings?.address?.locality}</span>
                    <span>{appSettings?.address?.location}</span>
                  </div>
                ) : seller?.seller?.addresses && seller?.seller?.addresses?.length > 1 ? (
                  <EBSSSModal
                    hideFooter
                    modalTitle={trans("website.addresses")}
                    toggle={() => toggle("address")}
                    modal={modal === "address"}
                    triggerEl={
                      <div
                        onClick={() => toggle("address")}
                        style={CSS({ cursor: "pointer" })}
                        className="d-flex flex-row gap-3 align-items-center badge bg-primary"
                      >
                        <i className="la la-home fs-4"></i>
                        <span className="fs-6">{trans("website.addresses")}</span>
                      </div>
                    }
                  >
                    {seller?.seller?.addresses && seller?.seller?.addresses?.length > 1 ? (
                      <div>
                        <h4 className="mb-4">{trans("website.our-addresses")}</h4>
                        {seller?.seller?.addresses?.map((addr, addrIdx) => (
                          <div key={addr.id} className="d-flex flex-row gap-3">
                            <i className="la la-home fs-5"></i>
                            <div className="d-flex flex-column gap-1">
                              <span>
                                {addr.address_line_1} {addr.address_line_2}
                              </span>
                              <span>{addr.postal_code}</span>
                              <span>{addr.locality}</span>
                              <span>{addr.location}</span>
                              {addrIdx !== seller?.seller?.addresses?.length - 1 ? <hr /> : <></>}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <></>
                    )}
                  </EBSSSModal>
                ) : seller?.seller?.addresses && seller?.seller?.addresses?.length === 1 ? (
                  <div className="d-flex flex-column">
                    <span>
                      {seller?.seller?.addresses[0]?.address_line_1} {seller?.seller?.addresses[0]?.address_line_2}
                    </span>
                    <span>{seller?.seller?.addresses[0]?.postal_code}</span>
                    <span>{seller?.seller?.addresses[0]?.locality}</span>
                    <span>{seller?.seller?.addresses[0]?.location}</span>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="mb-3" style={CSS({ minHeight: 200, marginTop: 50 })}>
          <SlickSlider
            slides={
              appSettings?.pictures?.map((d) => {
                return {
                  id: d.id,
                  image: d.path,
                  title: "",
                };
              }) ?? []
            }
            isGallery
            lazyLoad={true}
            rtl={false}
            title=""
            autoplay
            CTA={null}
            focusOnSelect={undefined}
          />
        </div>
        <Fragment>
          <Container fluid={true} className="product-wrapper">
            <div className="product-grid mb-3">
              <ProductFeatures
                values={values}
                setValues={setValues}
                categories={categories}
                sortBy={sortBy}
                setSortBy={setSortBy}
                filterSize={filterSize}
                setFilterSize={setFilterSize}
                stepSize={stepSize}
                setStepSize={setStepSize}
                filterPrice={filterPrice}
                setFilterPrice={setFilterPrice}
                basePath={"/crm/seller/" + getSeller?.slug}
                categoryPath={"/crm/seller/" + getSeller?.slug + "/category"}
                searchPath={"/crm/seller/" + getSeller?.slug + "/search"}
              />
              {!loaded ? (
                <div className="d-flex flex-row flex-wrap">
                  <SkeletonLoader isLoading={!loaded} />
                </div>
              ) : (
                <ProductGrid perLine={Number(appSettings?.columns)} products={products} trans={trans} values={values} sortBy={sortBy} filterSize={filterSize} />
              )}

              <EBSSSPagination page={page} data={products} />
            </div>
          </Container>
        </Fragment>
      </div>
    </Page>
  );
};

export default SellerPage;
